var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"name":"passport-form"}},[_c('PassportMain',{staticClass:"my-4",attrs:{"form":_vm.form,"data":_vm.data,"disabled":_vm.isView,"skeleton":_vm.skeleton,"is-create":_vm.isCreate,"is-view":_vm.isView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }